import { escapeHtml } from '../lib/escape';
import { state } from '../state';
import type { AnswerPrompt, PromptAlternative } from '../types';

export function renderPromptsList(prompts: AnswerPrompt[], optionIndex: number): string {
  if (prompts.length === 0) {
    return `<p class="prompts-empty">No prompts. Add one below.</p>`;
  }
  return `<div class="prompt-list" data-o="${optionIndex}">${prompts
    .map((p, pi) => renderPromptItem(p, optionIndex, pi))
    .join('')}</div>`;
}

export function renderPromptItem(
  p: AnswerPrompt,
  optionIndex: number,
  promptIndex: number,
): string {
  const common = `data-o="${optionIndex}" data-p="${promptIndex}" data-prompt-id="${p.id}"`;
  const altsHtml = p.alternatives
    .map((alt, ai) => renderAlternative(alt, optionIndex, promptIndex, ai, p.alternatives.length))
    .join('');

  return `
    <div class="prompt-item" ${common} draggable="true">
      <div class="prompt-item-header">
        <span class="prompt-item-handle" title="Drag to reorder">⋮⋮</span>
        <span class="prompt-item-kind">Prompt</span>
        <button type="button" class="prompt-item-delete" data-action="delete-prompt" title="Remove prompt">×</button>
      </div>
      <div class="prompt-item-alts">${altsHtml}</div>
      <div class="option-prompts-actions">
        <button type="button" class="prompt-add-btn" data-action="add-alt" data-o="${optionIndex}" data-p="${promptIndex}">+ Add alternative</button>
      </div>
    </div>
  `;
}

function renderAlternative(
  alt: PromptAlternative,
  optionIndex: number,
  promptIndex: number,
  altIndex: number,
  altCount: number,
): string {
  const knownNames = state.targets.map((t) => t.name);
  const isKnown = knownNames.includes(alt.target);
  const options = [
    `<option value="" ${alt.target === '' ? 'selected' : ''} disabled>— select target —</option>`,
    ...knownNames.map(
      (name) =>
        `<option value="${escapeHtml(name)}" ${name === alt.target ? 'selected' : ''}>${escapeHtml(name)}</option>`,
    ),
    !isKnown && alt.target !== ''
      ? `<option value="${escapeHtml(alt.target)}" selected>${escapeHtml(alt.target)} (unknown)</option>`
      : '',
  ].join('');
  const removeBtn = altCount > 1
    ? `<button type="button" class="prompt-alt-delete" data-action="delete-alt" data-o="${optionIndex}" data-p="${promptIndex}" data-alt="${altIndex}" title="Remove alternative">×</button>`
    : '';
  return `
    <div class="prompt-alt-row" data-o="${optionIndex}" data-p="${promptIndex}" data-alt="${altIndex}">
      <label class="prompt-item-sublabel">
        <span>Target</span>
        <select
          class="prompt-item-input prompt-item-targets"
          data-action="alt-target"
          data-alt="${altIndex}"
        >${options}</select>
      </label>
      <label class="prompt-item-sublabel">
        <span>Update</span>
        <textarea
          class="prompt-item-input prompt-item-updates"
          rows="1"
          data-action="alt-text"
          data-alt="${altIndex}"
          placeholder="update text"
        >${escapeHtml(alt.text)}</textarea>
      </label>
      ${removeBtn}
    </div>
  `;
}

export function renderPromptsSection(
  prompts: AnswerPrompt[],
  optionIndex: number,
): string {
  return `
    <div class="option-prompts" data-o="${optionIndex}">
      ${renderPromptsList(prompts, optionIndex)}
      <div class="option-prompts-actions">
        <button type="button" class="prompt-add-btn" data-action="add-prompt" data-o="${optionIndex}">+ Add prompt</button>
      </div>
    </div>
  `;
}
